import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateSkillRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}